import * as React from 'react'
import { type VariantProps, cva } from 'class-variance-authority'

import { cn } from '../helpers/index.js'

const badgeVariants = cva(
  'text-brand-0 outline-brand-0 inline-flex items-center justify-center whitespace-nowrap rounded-[16px] border-none text-xs font-bold outline outline-[1.6px] outline-offset-[-1.6px] transition-colors focus:outline-none',
  {
    variants: {
      size: {
        sm: 'h-[24px] px-[6px] pb-[3px] pt-[4px] text-[14px] leading-tight',
        lg: 'lg-desktop:px-[8px] lg-desktop:pb-[4px]  lg-desktop:pt-[5px] lg-desktop:text-[16px] lg-desktop:h-[28px] h-[24px] p-[6px] pb-[3px] pt-[4px] text-[14px] leading-tight',
      },
      variant: {
        outline: 'bg-transparent',
        fill: 'bg-brand-0 bg-gradient-brand text-white',
        promotional: 'bg-gradient-brand relative !border-none text-white !outline-none',
      },
      promotionalType: {
        'plus-member': 'bg-gradient-to-r from-[#6E6754] via-[#4A453A] to-[#070708] ',
        'regular-member': 'bg-brand-0 bg-gradient-brand ',
        'regular-discount': 'bg-brand-0 bg-gradient-brand ',
        'time-limited-discount': 'bg-brand-0 bg-gradient-brand ',
      },
    },
    compoundVariants: [
      {
        variant: 'promotional',
        size: 'sm',
        class: '!pl-[24px]',
      },
      {
        variant: 'promotional',
        size: 'lg',
        class: 'lg-desktop:!pl-[28px] !pl-[24px]',
      },
    ],
    defaultVariants: {
      size: 'lg',
      variant: 'outline',
    },
  }
)

// 会员标识图标
const PlusPromotionalIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 28" fill="none" className="h-full w-auto">
      <path
        d="M23.2222 0C24.2096 0 25.1341 0.501396 25.6903 1.34106L31.4814 10.0846C32.283 11.2948 32.1429 12.9193 31.1474 13.9659L19.0336 26.6998C17.3854 28.4319 14.6772 28.4335 13.0264 26.7039L0.855644 13.9536C-0.130438 12.9204 -0.281462 11.3186 0.492455 10.1091L6.07548 1.38199C6.6279 0.518743 7.56576 0 8.57008 0H23.2222Z"
        fill="url(#paint0_linear_22508_6946)"
      />
      <path
        d="M22.4084 10.2119C22.9545 9.66492 23.8409 9.66346 24.3881 10.2092C24.9351 10.7553 24.9366 11.6416 24.3908 12.1889L17.451 19.1397C16.8776 19.714 15.9474 19.7155 15.3729 19.1424L8.41114 12.1916C7.86414 11.6455 7.86268 10.7592 8.40841 10.2119C8.95451 9.66492 9.84087 9.66346 10.3881 10.2092L16.4092 16.2193L22.4084 10.2119Z"
        fill="url(#paint1_linear_22508_6946)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_22508_6946"
          x1="2.1318"
          y1="0.390243"
          x2="33.6892"
          y2="7.35765"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0865385" stopColor={'#FFF5E0'} />
          <stop offset="1" stopColor={'#E8C08A'} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_22508_6946"
          x1="7.79513"
          y1="9.80078"
          x2="25.937"
          y2="13.8215"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.9999" stopColor={'#6E6754'} />
          <stop offset="1" stopColor={'#050608'} />
        </linearGradient>
      </defs>
    </svg>
  )
}

const RegularMemberIcon = () => (
  <svg
    width="32"
    height="28"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-full w-auto"
  >
    <path
      d="M23.2222 0C24.2096 0 25.1341 0.501396 25.6903 1.34106L31.4814 10.0846C32.283 11.2948 32.1429 12.9193 31.1474 13.9659L19.0336 26.6998C17.3854 28.4319 14.6772 28.4335 13.0264 26.7039L0.855644 13.9536C-0.130438 12.9204 -0.281462 11.3186 0.492455 10.1091L6.07548 1.38199C6.6279 0.518743 7.56576 0 8.57008 0H23.2222Z"
      fill="#B5E5F9"
    />
    <path
      d="M22.4084 10.2119C22.9545 9.66492 23.8409 9.66346 24.3881 10.2092C24.9351 10.7553 24.9366 11.6416 24.3908 12.1889L17.451 19.1397C16.8776 19.714 15.9474 19.7155 15.3729 19.1424L8.41114 12.1916C7.86414 11.6455 7.86268 10.7592 8.40841 10.2119C8.95451 9.66492 9.84087 9.66346 10.3881 10.2092L16.4092 16.2193L22.4084 10.2119Z"
      fill="white"
    />
  </svg>
)

const NormalDiscountIcon = () => (
  <svg
    width="32"
    height="28"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-full w-auto"
  >
    <g clipPath="url(#clip0_20420_244316)">
      <path
        opacity="0.4"
        d="M3.90567 7.45107C4.19697 6.0806 5.21359 4.9787 6.55622 4.57818L13.8699 2.39643C15.1173 2.02431 16.4683 2.31148 17.4565 3.15879L23.2505 8.12665C24.3141 9.03864 24.7946 10.4588 24.5033 11.8292L21.3938 26.4587C20.9541 28.527 18.921 29.8474 16.8527 29.4077L3.74508 26.6216C1.67675 26.182 0.356442 24.1489 0.796078 22.0805L3.90567 7.45107Z"
        fill="#B5E5F9"
      />
      <path
        d="M5 7.9615C5 6.50843 5.78799 5.16965 7.05839 4.46433L14.0584 0.57797C15.266 -0.0924777 16.734 -0.0924768 17.9416 0.577971L24.9416 4.46434C26.212 5.16966 27 6.50844 27 7.9615V24C27 26.2091 25.2091 28 23 28H9C6.79086 28 5 26.2091 5 24V7.9615Z"
        fill="#B5E5F9"
      />
      <path
        d="M20.3094 17.6141C21.0396 17.6143 21.7533 17.8311 22.3603 18.2371C22.9672 18.6431 23.4402 19.22 23.7194 19.8949C23.9986 20.5698 24.0715 21.3124 23.9288 22.0287C23.7861 22.745 23.4343 23.4029 22.9178 23.9192C22.4013 24.4355 21.7434 24.787 21.0272 24.9293C20.311 25.0715 19.5687 24.9982 18.8942 24.7184C18.2197 24.4387 17.6433 23.9652 17.2378 23.3577C16.8324 22.7503 16.6161 22.0362 16.6163 21.3058C16.6163 19.2667 18.2697 17.6141 20.3094 17.6141ZM10.8221 20.5232L19.527 11.8217C19.7491 11.6041 20.0454 11.4786 20.3562 11.4704C20.667 11.4622 20.9695 11.5719 21.2028 11.7776C21.4361 11.9832 21.583 12.2695 21.6139 12.579C21.6449 12.8885 21.5577 13.1983 21.3698 13.4461L21.2677 13.5618L12.5628 22.2632C12.3407 22.4808 12.0444 22.6064 11.7336 22.6145C11.4228 22.6227 11.1203 22.513 10.887 22.3074C10.6537 22.1017 10.5068 21.8154 10.4759 21.5059C10.4449 21.1964 10.5321 20.8867 10.72 20.6388L10.8221 20.5232ZM20.3094 20.0752C19.9831 20.0752 19.6702 20.2049 19.4395 20.4356C19.2088 20.6664 19.0792 20.9794 19.0792 21.3058C19.0792 21.6322 19.2088 21.9452 19.4395 22.176C19.6702 22.4067 19.9831 22.5364 20.3094 22.5364C20.6357 22.5364 20.9486 22.4067 21.1793 22.176C21.41 21.9452 21.5396 21.6322 21.5396 21.3058C21.5396 20.9794 21.41 20.6664 21.1793 20.4356C20.9486 20.2049 20.6357 20.0752 20.3094 20.0752ZM11.6931 9C12.4232 9.00024 13.1369 9.21707 13.7439 9.62306C14.3509 10.0291 14.8239 10.606 15.1031 11.2809C15.3823 11.9558 15.4552 12.6983 15.3125 13.4146C15.1698 14.131 14.818 14.7889 14.3015 15.3052C13.785 15.8215 13.1271 16.173 12.4109 16.3152C11.6947 16.4575 10.9524 16.3841 10.2779 16.1044C9.60339 15.8246 9.02696 15.3511 8.6215 14.7437C8.21604 14.1362 7.99976 13.4221 8 12.6917C8 10.6527 9.65339 9 11.6931 9ZM11.6931 11.4612C11.5315 11.4611 11.3715 11.4928 11.2222 11.5546C11.073 11.6164 10.9373 11.7069 10.823 11.8212C10.5922 12.0518 10.4624 12.3648 10.4622 12.6911C10.4621 13.0175 10.5915 13.3306 10.8221 13.5615C11.0527 13.7923 11.3656 13.9222 11.6918 13.9223C12.0181 13.9223 12.331 13.7927 12.5617 13.5619C12.7924 13.3311 12.922 13.0181 12.922 12.6917C12.922 12.3654 12.7924 12.0524 12.5617 11.8216C12.331 11.5908 12.0181 11.4612 11.6918 11.4612H11.6931Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_20420_244316">
        <rect width="32" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const FlashDiscountIcon = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="h-full w-auto"
  >
    <path
      d="M0.112855 14.5991L6.23786 0.599179C6.3971 0.235193 6.75672 0 7.15401 0H19.4534C20.1791 0 20.6631 0.74862 20.3653 1.41036L16.5 10H22.5443C23.36 10 23.8326 10.9242 23.3549 11.5855L11.5 28.0001L9.6547 16L1.029 15.9999C0.307853 15.9999 -0.176196 15.2598 0.112855 14.5991Z"
      fill="#B5E5F9"
    />
    <path
      d="M0.112855 14.5991L6.23786 0.599179C6.3971 0.235193 6.75672 0 7.15401 0H19.4534C20.1791 0 20.6631 0.74862 20.3653 1.41036L16.5 10H22.5443C23.36 10 23.8326 10.9242 23.3549 11.5855L11.5 28.0001L9.6547 16L1.029 15.9999C0.307853 15.9999 -0.176196 15.2598 0.112855 14.5991Z"
      fill="#B5E5F9"
    />
  </svg>
)

// 促销类型图标映射
const PromotionalIcons = {
  'plus-member': () => <PlusPromotionalIcon />,
  'regular-member': () => <RegularMemberIcon />,
  'regular-discount': () => <NormalDiscountIcon />,
  'time-limited-discount': () => <FlashDiscountIcon />,
} as const

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {
  promotionalType?: 'plus-member' | 'regular-member' | 'regular-discount' | 'time-limited-discount'
}

/**
 * Badge - 徽章
 *
 * @description 用于显示状态、标签或计数的小型标识组件，支持不同尺寸和促销类型
 */
function Badge({ className, size, variant = 'outline', promotionalType, ...props }: BadgeProps) {
  const isPromotional = variant === 'promotional'

  // 根据 promotionalType 选择图标，如果没有指定则使用默认的 regular-discount
  const IconComponent = isPromotional ? PromotionalIcons[promotionalType || 'regular-discount'] : null

  return (
    <div
      className={cn(
        badgeVariants({
          size,
          variant,
          promotionalType: isPromotional ? promotionalType : undefined,
        }),
        className
      )}
      {...props}
    >
      {isPromotional && IconComponent && (
        <div className="absolute inset-y-0 left-0 flex -translate-x-1/3 items-center">
          <IconComponent />
        </div>
      )}
      <span className={isPromotional ? 'relative z-10' : ''}>{props.children}</span>
    </div>
  )
}

export default Badge
